import React, { useState } from 'react'
import { Box, Button, IconButton, Typography } from '@mui/material'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import { styled } from '@mui/material/styles'
import { FileUploadStatusLabel } from '~/src/components/molecules'
import {
  fileUpAreaMaskAreaStyle,
  fileUpAreaMaskStyle,
  fileUpAreaStyle,
  fileUpBoxStyle,
  LabelStyles,
} from './FileUploader.styles'

const Input = styled('input')({
  opacity: 0,
  height: '100%',
  width: '100%',
})

const Image = styled('img')({
  width: '200px',
  height: '120px',
})

const Section = styled('section')({})

interface IUploadFile {
  file?: string
  image?: string
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleDelete: () => void
  fileText: string
  uploadText: string
  isLoading: boolean
  isError: boolean
  optionWidth?: string
}

export const FileUploader: React.FC<IUploadFile> = ({
  file,
  image,
  handleFileChange,
  handleDelete,
  fileText,
  uploadText,
  isLoading,
  isError,
  optionWidth,
}) => {
  if (optionWidth) {
    fileUpAreaMaskStyle.width = optionWidth
    fileUpBoxStyle.width = optionWidth
    fileUpAreaMaskAreaStyle.width = optionWidth
  }
  return (
    <Section>
      <FileUploadStatusLabel
        file={file}
        loading={isLoading}
        hasError={isError}
        handleDelete={handleDelete}
      />

      <Box sx={image ? fileUpAreaMaskStyle : fileUpBoxStyle}>
        {image && <Box sx={fileUpAreaMaskAreaStyle} />}
        <IconButton aria-label="upload picture" sx={{ width: '70px', height: '70px' }}>
          <UploadFileIcon sx={{ width: '50px', height: '50px' }} />
        </IconButton>
        <Box sx={fileUpAreaStyle}>
          <Typography variant={'body1'} sx={LabelStyles}>
            {fileText}&nbsp;
          </Typography>
          <Button size={'small'} variant="outlined" startIcon={<FileUploadIcon />}>
            {uploadText}
          </Button>
          <Input
            sx={{
              position: 'absolute',
              top: 0,
            }}
            // accept="image/*"
            id="icon-button-file"
            type="file"
            onChange={handleFileChange}
          />
        </Box>
      </Box>
    </Section>
  )
}
